(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-documents-dossier", {
                parent: "entity",
                url: "/lebaniego-documents-dossier?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosDossier",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier.html",
                        controller:
                            "LebaniegoYearDocumentosDossierController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-documents-dossier.new", {
                parent: "lebaniego-documents-dossier",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-new.html",
                        controller: "LebaniegoYearDocumentosDossierNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-documents-dossier"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-dossier",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-documents-dossier.edit", {
                parent: "lebaniego-documents-dossier",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosDossier"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-detail.html",
                        controller: "LebaniegoYearDocumentosDossierDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-documents-dossier"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearDocumentosDossier",
                        function ($stateParams, LebaniegoYearDocumentosDossier) {
                            return LebaniegoYearDocumentosDossier.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-dossier",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
